<template>
	<div class="divcolumn">
		<div class="vertical-text">Consequence</div>
		<div style="position: relative; display: inline-block;">
			<div class="grid">
				<div v-for="(row, i) in colors" :key="i" class="row">
					<div
						v-for="(color, j) in row"
						:key="j"
						:class="{ box: true, point: isPoint(i, j) }"
						:style="{ backgroundColor: color, marginBottom: i === colors.length - 1 ? '25px' : '0' }"
					>
						<div :class="[isPoint(i, j) ? 'showpoint' : 'hidedivclass']">
							<div class="circledotclass"></div>
						</div>
						<h5 :class="[isPoint(i, j) ? getTagClass(i, j) : 'hidedivclass']">
							Risk {{ getPointRisk(i, j) }}
						</h5>
					</div>
				</div>
			</div>

			<svg
				style="position: absolute; top: 0; left: 0; pointer-events: none;"
				width="500"
				height="500"
			>
				<defs>
					<marker id="arrowhead" markerWidth="7" markerHeight="5" refX="0" refY="2.5" orient="auto">
						<polygon points="0 0, 7 2.5, 0 5" fill="black" :style="{ opacity: arrowOpacity }" />
					</marker>
				</defs>
				<line
					v-for="(coords, index) in lineCoordinates"
					:key="index"
					:x1="coords.x1"
					:y1="coords.y1"
					:x2="coords.x2"
					:y2="coords.y2"
					stroke="black"
					stroke-width="2"
					marker-end="url(#arrowhead)"
					stroke-dasharray="600"
					stroke-dashoffset="600"
				>
					<animate attributeName="stroke-dashoffset" from="600" to="0" dur="1s" fill="freeze" />
				</line>
			</svg>
		</div>

		<div>
			<div class="highriskred"><span>High</span></div>
			<div class="moderateriskyellow"><span>Moderate</span></div>
			<div class="lowriskgreen"><span>Low</span></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		offsetValue: {
			type: Number,
			default: 0
		},
		points: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			arrowOpacity: 0,
			colors: [
				["yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "red", "red", "red", "red", "red",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow",],
				["green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "green", "yellow", "yellow", "yellow", "yellow", "yellow",],
			],
		}
	},
	computed: {
		lineCoordinates() {
			const arrowLength = 15
			const coordinates = []

			// Group points belonging to the same Risk ID
			const groupedPoints = this.points.reduce((acc, point) => {
				if (!acc[point.risk]) {
					acc[point.risk] = []
				}
				acc[point.risk].push(point)
				return acc
			}, {})

			Object.values(groupedPoints).forEach((pts) => {
				for (let i = 0; i < pts.length - 1; i++) {
					const point1 = pts[i]     // First Point
					const point2 = pts[i + 1] // Latest / Updated Point

					const x1 = point1.y * 20 - 3
					const y1 = point1.x * 20 
					const x2 = point2.y * 20 - 3
					const y2 = point2.x * 20 

					const dx = x2 - x1
					const dy = y2 - y1
					const length = Math.sqrt(dx * dx + dy * dy) || 1

					const adjustedX2 = x2 - (dx / length) * arrowLength
					const adjustedY2 = y2 - (dy / length) * arrowLength

					coordinates.push({ x1, y1, x2: adjustedX2, y2: adjustedY2 })
				}
			})

			return coordinates
		}
	},
	watch: {
		points: {
			handler() {
				this.arrowOpacity = 0
				setTimeout(() => {
					this.arrowOpacity = 1
				}, 300)
			},
			immediate: false
		}
	},
	mounted() {
		setTimeout(() => {
			this.arrowOpacity = 1
		}, 900)
	},
	methods: {
		isPoint(row, col) {
			return this.points.some((point) => point.x === row && point.y === col)
		},
		getPointRisk(row, col) {
			const point = this.points.find((p) => p.x === row && p.y === col)
			return point ? point.risk : ""
		},
		getTagClass(x, y) {
			const point = this.points.find((p) => p.x === x && p.y === y)
			return point && (point.y > 21) ? "tagclass-left" : "tagclass-right"
		}
	}
}
</script>

<style scoped>
.grid {
	display: flex;
	flex-direction: column;
	width: 550px;
	height: 500px;
}

tr input {
	border: 0px;
}

.row {
	display: flex;
}

.box {
	width: 20px;
	height: 20px;
	border: 1px solid black;
}

.circledotclass {
	width: 10px;
	height: 10px;
	background-color: black;
	border-radius: 50%;
}

.highriskred {
	margin-top: 0px;
	margin-left: -35px;
	width: 25px;
	height: 20px;
	margin-right: 10px;
	background-color: red;
	border: solid 1px black;
}

.highriskred span {
	margin-left: 40px;
}

.moderateriskyellow {
	margin-top: 10px;
	margin-left: -35px;
	width: 25px;
	height: 20px;
	margin-right: 10px;
	background-color: yellow;
	border: solid 1px black;
}

.moderateriskyellow span {
	margin-left: 40px;
}

.lowriskgreen {
	margin-top: 10px;
	margin-left: -35px;
	width: 25px;
	height: 20px;
	margin-right: 10px;
	background-color: green;
	border: solid 1px black;
}

.lowriskgreen span {
	margin-left: 40px;
}

.spanclass1 {
	display: flex;
}

.spanclass2 {
	margin-top: -500px;
	margin-bottom: 500px;
	margin-left: 700px;
	display: flex;
	flex-direction: column;
}

.spanclass2 input {
	border: 1px solid #ccc;
	padding: 10px;
	padding-top: 0px;
}

.spanclass2input1 {
	width: 600px;
	height: 50px;
	padding-top: 0px;
	margin-top: 0px;
	align-items: top;
	font-size: 1.2rem;
}

.spanclass2 h3 {
	margin-left: 0px;
}

.spanclass2input2 {
	display: flex;
	width: 600px;
	height: 200px;
	padding-top: 0px;
	margin-top: 0px;
	align-items: top;
	font-size: 1rem;
}

.hidedivclass {
	display: none;
}

.showpoint {
	display: show;
	margin-top: 5px;
	margin-left: 5px;
	transform: scale(1);
}

.divtextclass {
	margin-top: 100px;
	display: flex;
	flex-direction: column;
}

.tagclass-left {
	position: absolute;
	margin-top: -19px;
	margin-left: -50px;
	transform: scale(1);
	background-color: white;
	border-radius: 2px;
	padding: 2px;
	padding-left: 5px;
	border: 1px solid black;
}

.tagclass-right {
	position: absolute;
	margin-top: -19px;
	margin-left: 20px;
	transform: scale(1);
	background-color: white;
	border-radius: 2px;
	padding: 2px;
	padding-left: 5px;
	border: 1px solid black;
}

.black {
	background-color: black;
	border-radius: 50%;
	position: relative;
	width: 10px;
	height: 10px;
	top: 5px;
	left: 5px;
}

.dotclass {
	margin-top: -20px;
	transform: scale(4);
}

.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 0px;
	margin-top: 0px;
}

.divoftable {
	display: flex;
	flex-direction: column;
	margin-top: 20px;
	display: flex;
	align-items: center;
	flex-direction: column;
}

.tableclass {
	border: 1px solid black;
}

.tdclass {
	margin-left: 0px;
	height: 10px;
	width: 10px;
	padding: 0;
	position: relative;
}

.riskdescriptiontopic {
	width: 200px;
}

.typesofrisktopic {
	width: 250px;
}

.riskownertopic {
	width: 250px;
}

.divcolumn {
	display: flex;
	align-items: left;
	margin-left: -660px;
}

.vertical-text {
	display: flex;
	flex-direction: column;
	margin-top: 100px;
	margin-right: 30px;
	color: #217b7f;
	writing-mode: vertical-rl;
	text-orientation: upright;
	white-space: nowrap;
	font-weight: 1000;
}

.probabilityclass {
	margin-left: -800px;
	margin-top: -250px;
	color: #217b7f;
	letter-spacing: 10px;
	font-weight: 1000;
}

.smallestitem {
	background-color: white;
	height: 20px;
	width: 20px;
	border: 1px solid black;
	display: flex;
	align-items: center;
	justify-content: center;
}

.addpointonmatrixbutton {
	background-color: #217b7f;
	color: white;
	padding-left: 10px;
	padding-right: 10px;
	padding-bottom: 5px
}

.repeatclass {
	display: flex;
	flex-direction: row;
}

.label {
	position: absolute;
	top: 100%;
	left: 0;
	width: 100%;
	text-align: center;
	font-size: 10px;
	color: white;
}

.form {
	margin-top: 20px;
	display: flex;
	align-items: center;
}

.form label {
	margin-right: 10px;
}

.form input {
	width: 50px;
	margin-right: 10px;
}

.form button {
	padding: 5px 10px;
	background-color: #2196f3;
	color: white;
	border: none;
	border-radius: 3px;
	cursor: pointer;
}

.form button:hover {
	background-color: #0b7dda;
}

.pnt {
	margin-top: 20px;
}

.pnt h3 {
	margin-bottom: 10px;
}

.pnt ul {
	list-style: none;
	padding: 0;
}

.pnt li {
	margin-bottom: 5px;
}

.esgtable {
	margin-top: 30px;
	display: flex;
	align-items: center;
	margin-left: 0px;
	flex-direction: column;
	margin-right: 0px;
}

.addnewbutton {
	display: flex;
	justify-content: flex-end;
	margin-left: 270px;
}

.addnewriskbutton {
	font-size: 1rem;
	background-color: #217b7f;
	display: flex;
	align-items: flex-start;
	color: white;
	padding: 3px;
}

.rowofheadings {
	font-size: 1.2rem;
}

table {
	border: 1px solid gray;
	width: 123%;
}

th {
	padding: 10px;
	width: 1400px;
	height: 50px;
}

th,
tr {
	text-align: flex-start;
}

tr {
	width: 1300px;
	font-size: 1.5rem;
	border-left: 0.5px solid gray;
	border-right: 0.5px solid gray;
}

th {
	background-color: white;
	color: #217b7f;
	width: 150px;
	margin: 50px;
}

td {
	border-top: 1px solid gray;
	margin: 10px;
}

tr input {
	width: 100px;
	margin: 10px;
	color: #055522;
}

td input {
	font-size: 20px;
}
</style>